<andor-square-icon-btn
  [variant]="sharing() ? 'active' : 'default'"
  [disabled]="blocked()"
  [tooltip]="
    blocked()
      ? ('Your current role &quot;[role]&quot; is not permitted to stream video in this room.'
        | translate: { role: appService.roleName() })
      : ((sharing() ? 'Stop Screen Sharing' : 'Start Screen Sharing') | translate)
  "
  [tooltipTitle]="blocked() ? ('Video not permitted' | translate) : null"
  [tooltipVariant]="blocked() ? 'warning' : 'default'"
  (clicked)="toggle()">
  <fa-duotone-icon [icon]="faScreencast"></fa-duotone-icon>
</andor-square-icon-btn>
